import { useState } from "react";
import {
    Card,
    CardActionArea,
    CardContent,
    Typography,
    Modal,
    Box,
} from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { CustomIconButton } from "../../utils/IconButton";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ShareIcon from "@mui/icons-material/Share";
import { ScrollButton } from "./ScrollComponent";
import { ArrowLeftIcon, ArrowRightIcon } from "@mui/x-date-pickers";
import { getFileUrl } from "../../utils/getFileUrl";

const HighLightCard = ({ images, title, img }) => {
    const [open, setOpen] = useState(false);
    // const message = "Check out this awesome Memory!";

    // const encodedMessage = encodeURIComponent(`${message} ${img}`);
    // const handleWhatsAppShare = () => {
    //     window.open(
    //         `https://wa.me/?text=${encodedMessage}`,
    //         '_blank',
    //         'noopener,noreferrer'
    //     );
    // };
    return (
        <>
            <Card
                sx={{
                    position: "relative",
                    maxWidth: "100%",
                    height: "350px",
                    backgroundImage: `url("${getFileUrl(img)}")`,

                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    borderRadius: "15px",
                    overflow: "hidden",
                    boxShadow: "none",
                }}
            >
                <CardActionArea
                    onClick={() => setOpen(true)}
                    sx={{ height: "100%", display: "flex", alignItems: "flex-end" }}
                >
                    <Box
                        sx={{
                            position: "absolute",
                            bottom: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            background: "linear-gradient(180.08deg, rgba(0, 0, 0, 0) 50%, #000000 99.93%)",
                            zIndex: 1,
                        }}
                    ></Box>
                    <CardContent sx={{ position: "relative", zIndex: 2, textAlign: "center", width: "100%", py: "21px" }}>
                        <Typography variant="h5" fontWeight={500} color="white">
                            Remember the day ?
                        </Typography>
                    </CardContent>
                </CardActionArea>
            </Card>

            <Modal open={open} onClose={() => setOpen(false)}>
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: { lg: "30%", xs: "80%" },
                        bgcolor: "white",
                        boxShadow: 24,
                        borderRadius: "30px",
                    }}
                >
                    <Swiper
                        modules={[Pagination, Autoplay, Navigation]}
                        pagination={{ type: "progressbar" }}
                        autoplay={{ delay: 2000 }}
                        loop={true}
                        navigation={{ nextEl: ".custom-swiper-next", prevEl: ".custom-swiper-prev" }}
                        style={{ width: "100%", height: "60vh", position: "relative" }}
                    >
                        {images.map((img, index) => (
                            <SwiperSlide key={index} style={{ position: "relative" }}>
                                <div
                                    style={{
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        width: "100%",
                                        height: "100%",
                                        background: `linear-gradient(0deg, rgba(0, 0, 0, 0) 78.06%, rgba(0, 0, 0, 0.5) 98.53%)`,
                                        borderTopLeftRadius: "30px",
                                        borderTopRightRadius: "30px",
                                        zIndex: 1
                                    }}
                                />
                                <img
                                    src={getFileUrl(img)}
                                    alt={`Slide ${index}`}
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        borderTopLeftRadius: "30px",
                                        borderTopRightRadius: "30px",
                                        objectFit: "cover",
                                        position: "relative",
                                        zIndex: 0
                                    }}
                                />
                            </SwiperSlide>
                        ))}
                    </Swiper>

                    <ScrollButton className="custom-swiper-prev" style={{ left: 5, top: "45%" }} >
                        <ArrowLeftIcon sx={{ fontSize: "25px" }} />
                    </ScrollButton>
                    <ScrollButton className="custom-swiper-next" style={{ right: 5, top: "45%" }}>
                        <ArrowRightIcon sx={{ fontSize: "25px" }} />
                    </ScrollButton>
                    {/* <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", px: 3, pt: 1, pb: 2 }}>
                        <Box>
                            <Typography variant="h5">
                                Remember the day ?
                            </Typography>
                            <Typography variant="body2" color="secondary.light">
                                21 Jan  2025  Jp Nagar 8th Phase
                            </Typography>
                        </Box>
                        <Box>
                            <CustomIconButton onClick={handleWhatsAppShare } icon={<ShareIcon sx={{ fontSize: "18px" }} />} />
                            <CustomIconButton icon={<MoreVertIcon sx={{ fontSize: "25px" }} />} />
                        </Box>
                    </Box> */}
                </Box>
            </Modal>
        </>
    );
};

export default HighLightCard;
